import React from 'react'

import { Switch as AntDSwitch } from 'antd'
import PropTypes from 'prop-types'

import Label from '../Label/Label'
import styles from './Switch.module.css'

const Switch = ({
  checked,
  disabled,
  isInline,
  label,
  labelClassName,
  onChange
}) => {
  const className = isInline ? styles['inline-switch-button'] : styles['switch-button']
  return (
    <>
      <Label
        className={labelClassName}
        isInline={isInline}
        value={label}
      />
      <AntDSwitch
        checked={checked}
        className={className}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  isInline: PropTypes.bool,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

Switch.defaultProps = {
  checked: false,
  labelClassName: '',
  disabled: false,
  isInline: false
}

export default Switch
